import {totalWeeksRequired} from "./tools";

export default class FacilityInformation {
  constructor(location, history) {
    this.location = location;
    this.history = history;
  }

  /**
   *
   * @returns {string}
   */
  getHTML() {
    const location = this.location;
    switch (location.id) {
      case "DHT":
        return this._getDHT();
      case "FacilityA":
        return this._getFacilityA();
      case "FacilityB":
        return this._getFacilityB();
      case "FacilityC":
        return this._getFacilityC();
      default:
        return "";
    }
  }

  /**
   *
   * @returns {string}
   * @private
   */
  _getDHT() {
    if (this.location.adoption >= 80) {
      return `
      <div class="flex flex-col lg:flex-row lg:items-center">
        <div class="w-full lg:w-7/12 lg:px-6 transform lg:-translate-y-16">
          <p class="font-bold text-lg lg:text-2xl leading-tight mb-6">
            Week ${totalWeeksRequired(this.history)}
          </p>
          <p class="font-bold text-lg lg:text-2xl leading-tight mb-3">
            District Health Team
          </p>
          <p class="leading-tight lg:text-lg pb-6 lg:w-10/12">
            The district team is engaging in active supportive supervision to assist the facility level with problem solving and micro planning.
          </p>
        </div>
        <div class="w-full lg:w-5/12 ml-auto">
          <img src="/img/changemanagement/map1@2x.png" alt="" class="w-full mb-6"/>
        </div>
      </div>`
    }

    return `
    <div class="flex flex-col lg:flex-row">
      <div class="w-full lg:w-7/12 lg:px-6">
        <p class="font-bold text-lg lg:text-2xl leading-tight mb-3 w-2/3 lg:w-auto">
          District Health Team
        </p>
        <p class="leading-tight lg:text-lg pb-6">
          Niand district is largely rural, with one larger city. Dispersed populations and mountainous terrains mean that it can be challenging to reach all populations with health services.<br/><br/>
          The total population of the district is estimated at 118,000. Last year, there were 4,130 live births and 4,033 surviving infants in this district.<br/><br/>
          Only 69% of infants received a third dose of pentavalent vaccine last year in this district, compared to 83% in the country as a whole. Health facility staff turnover is high, almost 30% lastyear.<br/><br/>
          The district health team provides supervision to health facilities.
        </p>
      </div>
      <div class="w-full lg:w-5/12 ml-auto">
        <img src="/img/changemanagement/map1@2x.png" alt="" class="w-full mb-6"/>
      </div>
    </div>`
  }

  /**
   *
   * @returns {string}
   * @private
   */
  _getFacilityA() {
    if (this.location.adoption >= 80) {
      return `
      <div class="flex flex-col lg:flex-row">
        <div class="w-full lg:w-7/12 lg:px-6">
          <p class="text-xl font-bold lg:mt-6 mb-2">
            Facility A
          </p>
          <p class="leading-tight text-lg pb-6">
            This facility is now regularly using quality improvement teams for problem solving and more effective micro planning, with the active input of the community.
          </p>
        </div>
        <div class="w-full lg:w-5/12 ml-auto">
          <img src="/img/changemanagement/map-a.svg" alt="" class="w-full mb-6"/>
        </div>
      </div>`
    }
    return `
    <div class="flex flex-col lg:flex-row">
      <div class="w-full lg:w-7/12 lg:px-6">
        <p class="text-xl font-bold lg:mt-6 mb-2">
          Facility A
        </p>
        <p class="leading-tight text-lg pb-6">
          This is a relatively high-performing rural health facility. Last year, 86% of infants received a third dose of pentavalent vaccine.<br/><br/>
          <strong>To learn more about the team, you will need to send a team to gather additional information.</strong>
        </p>
      </div>
      <div class="w-full lg:w-5/12 ml-auto">
        <img src="/img/changemanagement/map-a.svg" alt="" class="w-full mb-6"/>
      </div>
    </div>`
  }

  /**
   *
   * @returns {string}
   * @private
   */
  _getFacilityB() {
    return `
    <div class="flex flex-col lg:flex-row">
      <div class="w-full lg:w-7/12 lg:px-6">
        <p class="text-xl font-bold lg:mt-6 mb-2">
          Facility B
        </p>
        <p class="leading-tight text-lg pb-6">
          This is a lower-performing rural health facility. Last year, 62% of infants received a third dose of pentavalent vaccine.<br/><br/>
          <strong>To learn more about the team, you will need to send a team to gather additional information.</strong>
        </p>
      </div>
      <div class="w-full lg:w-5/12 ml-auto">
        <img src="/img/changemanagement/map-b.svg" alt="" class="w-full mb-10"/>
      </div>
    </div>`
  }

  /**
   *
   * @returns {string}
   * @private
   */
  _getFacilityC() {
    return `
    <div class="flex flex-col lg:flex-row">
      <div class="w-full lg:w-7/12 lg:px-6">
        <p class="text-xl font-bold lg:mt-6 mb-2">
          Facility C
        </p>
        <p class="leading-tight text-lg pb-6">
          This is a medium-performing urban health facility. Last year, 73% of infants received a third dose of pentavalent vaccine.<br/><br/>
          <strong>To learn more about the team, you will need to send a team to gather additional information.</strong>
        </p>
      </div>
      <div class="w-full lg:w-5/12 ml-auto">
        <img src="/img/changemanagement/map-c.svg" alt="" class="w-full mb-10 lg:mt-10"/>
      </div>
    </div>`
  }
}
